import React, { useContext } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";

import { ISXContext } from "services/Utils";

// const DATE_FORMAT = "DD MMM YYYY HH:mm:ss";

const InfoDialog = (props) => {
  const isxContext = useContext(ISXContext);

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <DialogTitle align="center">
        About {isxContext.labels.platform}
      </DialogTitle>
      <DialogContent dividers>
        <img
          src={
            (isxContext.logo && isxContext.logo.url) ??
            "https://www.interstacks.com/wp-content/themes/boxpress/assets/img/branding/interstacks-logo.png"
          }
          height={(isxContext.logo && isxContext.logo.height) ?? 72}
          alt="Interstacks Logo"
        />
        <DialogContentText variant="body1" align="center">
          Version {process.env.REACT_APP_VERSION}
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default InfoDialog;
